<div class="flex items-center datepicker">
  <input [matDatepicker]="picker" class="app-trim-ignore blend-border" (click)="picker.open()"  [placeholder]="placeholder" [formControl]="formControl">
  <mat-icon svgIcon="calendar_today" class="datepicker-icon" (click)="picker.open()"></mat-icon>
  <mat-datepicker #picker></mat-datepicker>
</div>
